module.exports = __webpack_public_path__ + "img/img-trabalhe-conosco.0e7bf43c.jpeg";